import React from 'react';

import { ONE_DASHBOARD_BASE_URL } from 'helpers/constants';
import { ReactComponent as IconBell } from 'images/icon-bell.svg';

import styles from './styles.module.scss';

const AnnouncementBanner = () => (
  <div className={styles.announcementBanner}>
    <IconBell className={styles.iconBell} />
    We're working on a{' '}
    <a href={ONE_DASHBOARD_BASE_URL} target="_blank">
      new experience
    </a>
    . Try it out and tell us what you think.
  </div>
);

export default AnnouncementBanner;
